import { ListingType } from '../mintAsks/interface';

export type UserPageFilterCondition = {
  availability: 'all' | 'sold' | 'available';
  sort: 'newest' | 'oldest';
};

export type LimitedCollectionToken = {
  aniftyTokenID: number;
  imageURL: string;
  tokenName: string;
  creatorName: string;
};

export type CollectedToken = {
  aniftyTokenID: number;
  creationID?: number;
  imageURL: string;
  tokenName: string;
  tokenNameJA: string | null;
  width?: number;
  height?: number;
  cropStartX?: number;
  cropStartY?: number;
  cropSize?: number;
  creatorProfile: {
    displayNameEN?: string;
    displayNameJP?: string | null;
    profilePicUrl?: string | null;
  } | null;
  price?: string;
  holdingTokenAmount: number;
  totalTokenAmount?: number;
  availableTokenAmount?: number;
  listingType: ListingType;
  highestBidPrice: string | null;
  endTime: string | null;
};

export type CreatedToken = {
  aniftyTokenID: number;
  creationID?: number;
  imageURL: string;
  tokenName: string;
  tokenNameJA: string | null;
  width?: number;
  height?: number;
  cropStartX?: number;
  cropStartY?: number;
  cropSize?: number;
  creatorProfile: {
    displayNameEN?: string;
    displayNameJP?: string | null;
    profilePicUrl?: string | null;
  } | null;
  price?: string;
  reservedAt: string | null;
  totalTokenAmount?: number;
  availableTokenAmount?: number;
  listingType: ListingType;
  highestBidPrice: string | null;
  endTime: string | null;
};

// export type TokenWithoutCreatorProfile = Omit<Token, 'creatorProfile'>;

export type BaseUser = {
  userID: string;
  typeID: number;
  emailAddress: string | null;
  userName: string | null;
  nonce: number;
  about: string | null;
  profilePicUrl: string | null;
  headerImageURL: string | null;
  twitterID: string | null;
  portfolioLinks: string[];
  emailModalSeenAt: Date | null;
  collectedLimitedCollections: LimitedCollectionToken[] | null;
  collectorProfile: {
    displayName: string | null;
    displayNameJA?: string | null;
  } | null;
};

export type Collector = BaseUser & {
  creatorProfile: null;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const isCollector = (arg: any): arg is Collector => {
  return arg?.typeID === 1;
};

type CreatorProfile = {
  nameJA: string | null;
  nameEN: string;
  pixivID: string | null;
};

export type DraftToken = {
  creationID: number;
  name: string;
  description: string;
  nameJa: string;
  descriptionJa: string;
  imageUrl: string;
  width: number;
  height: number;
  cropStartX: number;
  cropStartY: number;
  cropSize: number;
};

export type Creator = BaseUser & {
  creatorProfile: CreatorProfile;
  draftTokens: DraftToken[];
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const isCreator = (arg: any): arg is Creator => {
  return arg?.typeID === 2;
};

export type User = Collector | Creator;

/**
 * [post] /users/:userID/profile_images
 */
export type PostProfileImageResponse = {
  userID: string;
  profilePicUrl: string | null;
};

/**
 * [POST] /users/:userID/header_image
 */
export type PostHeaderImageResponse = {
  userID: string;
  headerImageURL: string | null;
};

/**
 * [get] /users/:userID/profile
 */
export type UserWithProfile = {
  userID: string;
  userName: string | null;
  typeID: number;
  about: string | null;
  profilePicUrl: string | null;
  creatorProfile: {
    displayNameEN: string;
    displayNameJA: string | null;
    isDiscounted: boolean;
    isVerified: boolean;
  } | null;
  collecterProfile: {
    displayName: string;
    isVerified: boolean;
  } | null;
};

/*
For use within CollectorList
*/
export type UserCollector = {
  UserID: string;
  About: string | null;
  Address: string | null;
  ProfilePicUrl: string | null;
  TypeID: number;
  TwitterID: string | null;
  UserName: string | null;
  CreatedAt: Date;
  UpdatedAt: Date;
  HeaderImageURL: string | null;
};

export type GetCollectorsResponse = UserCollector[];

/**
 * [get] /users/:userID/liked_creations
 */
export type LikedCreationList = {
  nextPageToken: string | null;
  likedCreations: LikedCreation[];
};
export type LikedCreation = {
  creationID: number;
  imageURL: string;
  width: number;
  height: number;
  cropStartX: number;
  cropStartY: number;
  cropSize: number;
  listingType: ListingType | null;
  aniftyTokenID: number | null;
  tokenName: string;
  tokenNameJA: string | null;
  creatorProfile: {
    displayNameJP: string | null;
    displayNameEN: string | null;
    profilePicUrl: string | null;
  };
  price: string | null;
  highestBidPrice: string | null;
};
